import {ChangeDetectionStrategy, Component, computed, input} from "@angular/core";
import {AccountModel} from "../../models/account.model";

@Component({
  selector: "app-shipper-account-link-tooltip",
  templateUrl: "./shipper-account-link-tooltip.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShipperAccountLinkTooltipComponent {
  readonly account = input<AccountModel>();

  readonly params = computed(() => ({id: this.account()?.id}));
}
